export default __webpack_public_path__ + "static/media/plain-sticker-E.3082b7a8.png";